import React from 'react';

import { Split } from '@dropbox/dig-foundations';
import { Button } from '@dropbox/dig-components/buttons';

import { defineMessages, FormattedMessage, useIntl } from 'react-intl';
import useInsertSignature from './use-insert-signature';
import { SignatureData } from './signature-modal-v2';
import { SigData } from '../context/signer-app-client/signature';
import { SignatureModalContext } from './signature-modal-context/context';
import { Tab } from './modal';

const messages = defineMessages({
  fillAllButton: {
    id: '5a3f40ccd6492d50be3d0e4d7550ecce763f9f36a5cc5fa8c8c47c89627085ad',
    description:
      'Text for a button that inserts the users signature into all signature fields.',
    defaultMessage: 'Fill in all fields',
  },
  fillAllButtonDrawer: {
    id: 'c4f1e4f98a949d4439365da30b5f2c0c464e2b47885d24f5c7732e709d52aaa4',
    description:
      'Text for a button that inserts the users signature into all fields field.',
    defaultMessage: 'Insert everywhere',
  },
});

type SignatureButtonsProps = {
  selectedTab: Tab;
  canInsertEverywhere: boolean;
  onInsert: (signatureData: SigData | null, insertEverywhere: boolean) => void;
  getSignatureData: () => SignatureData | null;
  createNewSignature: SignatureModalContext['createNewSignature'];
  disabled: boolean;
  buttonText?: string;
  isDrawerView?: boolean;
};
export default function SignatureButtons({
  selectedTab,
  canInsertEverywhere,
  onInsert,
  getSignatureData,
  createNewSignature,
  disabled,
  buttonText,
  isDrawerView,
}: SignatureButtonsProps) {
  const intl = useIntl();

  const { insertSignature, insertSignatureEverywhere } = useInsertSignature(
    selectedTab,
    onInsert,
    getSignatureData,
    createNewSignature,
  );

  return (
    <Split
      direction={isDrawerView ? 'vertical' : 'horizontal'}
      gap={isDrawerView ? 'Micro Large' : 'Micro XSmall'}
      width={isDrawerView ? '100%' : 'fit-content'}
      isFlexGap
    >
      <Split.Item>
        <Button
          size={isDrawerView ? 'large' : 'medium'}
          fullWidth={isDrawerView}
          variant="primary"
          data-testid="singing-modal--insert-btn"
          aria-describedby="signature-modal-footer-disclosure"
          onClick={() => insertSignature()}
          disabled={disabled}
          key="insert"
        >
          {!!buttonText && !canInsertEverywhere ? (
            buttonText
          ) : (
            <FormattedMessage
              id="9bff1672b61adc544d8534e321758d32dac6ef7e9b0c5cc49e318ba7c7f661e9"
              description="Text for a button that inserts the users signature into a field."
              defaultMessage="Insert"
            />
          )}
        </Button>
      </Split.Item>

      {canInsertEverywhere && (
        <Split.Item>
          <Button
            size={isDrawerView ? 'large' : 'medium'}
            fullWidth={isDrawerView}
            variant={isDrawerView ? 'opacity' : 'primary'}
            data-testid="insert-everywhere-btn"
            aria-describedby="signature-modal-footer-disclosure"
            onClick={() => insertSignatureEverywhere()}
            disabled={disabled}
            key="insert everywhere"
          >
            {isDrawerView
              ? intl.formatMessage(messages.fillAllButtonDrawer)
              : intl.formatMessage(messages.fillAllButton)}
          </Button>
        </Split.Item>
      )}
    </Split>
  );
}
